/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  isShowing: false
});

export default function subscriptionActivation(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'HIDE_SUBSCRIPTION_ACTIVATION_MODAL':
      return INITIAL_STATE;
    case 'SUBSCRIPTION_SHOW_ACTIVATION_MODAL':
      return state.set('isShowing', true);
    default:
      return state;
  }
}
